// extracted by mini-css-extract-plugin
module.exports = {"ParentContainer":"DashboardLayout_ParentContainer__1EHAI","TopContainer":"DashboardLayout_TopContainer__22he0","ChildrenContainer":"DashboardLayout_ChildrenContainer__IhfES"};